<template>
  <div id="app">
    <!-- START NAVBAR -->
    <Navbar />
   


    <div >
      <router-view />
    </div>

    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/tabbar/navbar.vue';
import Footer from '@/components/tabbar/footer.vue';
export default {
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
   
    };
  },
  created() {
    
  },
  mounted() {

   
      
  },
  methods: {


  },
  watch: {
  
  }
};
</script>

